<template>
  <div class="commit-report">
     <z-fix-top
      keep-position
      class="fixtop"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          title="举报"
          @click-left="closePage"
      ></z-nav-bar>
    </z-fix-top>
    <div class="reason-scroll">
      <div class="guide-tip">
        <span>{{ guideTip }}</span>
      </div>
      <p class="guide-orderList" v-if="isHastradingorder">
        <Icon name="bulb-o" color="red" class="icon" />
        系统识别出您与对方的订单暂未确认收货，在举报的同时您可以通过【申请退货退款】来挽回损失。<span
          @click="jumpTo()"
          >点击进入订单列表</span
        >&nbsp;选择相应订单进入并操作。如遇问题，可到【我的-客服中心】寻求帮助
      </p>
      <section v-if="isChatHistoryEnabled" class="chat-history-proof">
        <header>聊天证据</header>
      </section>
      <section class="process-desc">
        <header>过程描述</header>
        <textarea
          id="desc"
          v-model="desc"
          :placeholder="descPlaceholder"
          maxlength="200"
        ></textarea>
        <span class="desc-length">{{ remainDescLength }}</span>
      </section>
      <section class="snapshot-proof">
        <header>截图凭证</header>
        <div class="snapshot-tip">{{ snapshotTip }}</div>
        <div class="upload-area">
          <z-upload
              v-model="imageFiles"
              accept="image/*"
              :process-file="processFile"
              :max="9"
            />
          <div class="empty" style="clear: both;"></div>
        </div>
      </section>
    </div>
    <!-- 下一步 -->
    <z-button-group>
      <z-button type="primary" :loading="loading" :disabled="isDisable" @click="submitReport">提交</z-button>
    </z-button-group>
  </div>
</template>

<script>
import compress from '@zz-common/zz-ui/lib/utils/image'
import { Icon, Dialog, Upload, Button, ButtonGroup, NavBar, FixTop } from '@zz-common/zz-ui'
import setPicSize from '@zz-app/setPicSize'
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import { fkAddReport, getantispamresult, hastradingorder } from '@api/resourceApi'
import { toast } from '../../../native'
import { queryParams } from '../../../lib/utils'

const MAX_DESC_LENGTH = 200
const query = queryParams()

export default {
  name: 'CommitReport',
  data() {
    return {
      beReportedUid: this.$route.query.beReportedUid || query.toUid, //对方uid
      from: this.$route.query.from || query.from || 10, //来源
      reportId: this.$route.query.reportId || query.id || '', //补充举报id
      isSupplyReport: this.$route.query.isSupplyReport || query.isSupplyReport || '1', //判断是否是补充举报，还是别的来源的举报
      desc: '', //描述
      descLength: 0,
      imageFiles: [],
      isHastradingorder: false,
      loading: false,
      //别的来源的参数过来的提交数据
      reasonId: this.$route.reasonId || query.reasonId || '',
      chooseType: this.$route.query.chooseType || query.chooseType || '',
      chooseEvidence: this.$route.query.chooseEvidence || query.chooseEvidence || '',
      moneyLoss: this.$route.query.moneyLoss || query.moneyLoss || '',
      native
    }
  },
  // eslint-disable-next-line vue/no-unused-components
  components: {
    Icon,
    zUpload: Upload,
    zButton: Button,
    zButtonGroup: ButtonGroup,
    'z-fix-top': FixTop,
    'z-nav-bar': NavBar
  },
  computed: {
    remainDescLength() {
      return this.desc.length + '/' + MAX_DESC_LENGTH
    },
    guideTip() {
      return '请补全对方违规证据'
    },
    descPlaceholder() {
      return this.isSupplyReport == '1'
        ? '请您在上次举报描述的基础上，尽可能详细描述您的受骗过程，包括对方联系您的方式、交易方式等，以帮助我们快速定位。'
        : '请尽可能详细描述您举报的原因及完整过程，以帮助我们快速定位'
    },
    snapshotTip() {
      return this.isSupplyReport == '1'
        ? '请根据“反馈中平台建议”补充有效截图凭证，上次举报中已提交过的截图请勿重复提交'
        : '请提供对方违规的有效凭证，以帮助我们快速定位。如对方引导您转转外沟通，可提供聊天记录截图等证据'
    },
    isChatHistoryEnabled() {
      return false
    },
    isDisable() {
      return !this.desc.length || !this.imageFiles.length
    }
  },
  methods: {
    setPicSize,
    processFile(file, next) {
      // 开启图片压缩，提高上传的速度，同时修正拍摄的图片方向和显示的问题
      compress(file, {
        compress: true
      }, next)
    },
    closePage() {
      native.close()
    },
    showToast(msg) {
      toast({
        msg,
        style: '2'
      })
    },
    //不能举报
    getantispamresult() {
      return getantispamresult({
        toUid: this.beReportedUid,
        from: this.from,
        type: 10,
        subOp: '10', // 举报原因页阻止弹窗subOp=10
        opType: '47'
      })
        .then((res) => {
          console.log('---hastradingorder---', res)
          this.alertMsg = res.message || '不能举报'
          if (res.result === 'HIT') {
            Dialog({
              // title: '标题',
              message: res.message || '不能举报'
              // closeOnClickOverlay: true
            }).then(() => {
              native.close()
            })
          }
        })
        .catch((err) => {
          console.error(err)
          if (!err.errMsg) return
          toast({
            msg: err.errMsg,
            style: '2'
          })
        })
    },
    //交易列表
    getHastradingorder() {
      return hastradingorder({
        toUid: this.beReportedUid
      })
        .then((res) => {
          console.log('---hastradingorder---', res)
          if (res == '1' && native.client !== 'zzseller') {
            this.isHastradingorder = true
          } else if (res == '0') {
            this.isHastradingorder = false
          }
          console.log('---isHastradingorder---', this.isHastradingorder)
          this.reportDetial = res
          return res
        })
        .catch((err) => {
          console.error(err)
          if (!err.errMsg) return
          toast({
            msg: err.errMsg,
            style: '2'
          })
        })
    },
    jumpTo() {
      lego.send({
        pagetype: 'ZZUP_REPORT_COMMIT',
        actiontype: 'ORDER_LIST_CLICK'
      })
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/trade/order-list/buy.html',
        newPageTitle: '我买到的'
      })
    },
    submitReport() {
      if (this.desc.length === 0) return this.showToast('请填写过程描述后再提交')
      lego.send({
        pagetype: 'ZZUP_REPORT_COMMIT',
        actiontype: 'SUBMIT_CLICK',
        backup: {
          from: this.from,
          reasonId: this.reasonId
        }
      })
      const params = {
        toUid: this.beReportedUid,
        from: this.from,
        reportId: this.reportId,
        content: this.desc,
        pics: this.imageFiles.map(item => item.url).join('|'),

        reasonId: this.reasonId,
        chooseType: this.chooseType,
        chooseEvidence: this.chooseEvidence,
        moneyLoss: this.moneyLoss
      }
      this.loading = true;
      fkAddReport(params)
        .then((_data) => {
          this.loading = false
          toast({
            msg: '提交成功',
            style: '1'
          })
          //  提交成功后 2s 关闭页面
          setTimeout(() => {
            native.close()
          }, 1000)
        })
        .catch((err) => {
          console.log('submiterror', err);
          this.loading = false
          //  提交失败后 2s 关闭页面
          setTimeout(() => {
            // native.close()
          }, 1000)
        })
    }
  },
  mounted() {
    this.getantispamresult()
    this.getHastradingorder()
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
